<template>
  <b-container>
    <ArtistEditProfileTabs />

    <b-row>
      <b-col>
        <h4>Your payout method</h4>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="hasPayoutMethod">
        Your account is connected to Stripe.
        For details, visit your <a href="https://dashboard.stripe.com/">Stripe dashboard</a>.
      </b-col>
      <b-col v-else>
        Payouts are not set up. Please
        <router-link :to="{name: 'artist-onboarding'}">connect with Stripe</router-link> to continue.
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  a {
    color: $white;
    text-decoration: underline;
  }
</style>

<script>
import { mapGetters } from 'vuex'

import ArtistEditProfileTabs from '@/components/widgets/ArtistEditProfileTabs'

export default {
  name: 'Home',
  components: {
    ArtistEditProfileTabs
  },
  computed: {
    ...mapGetters('artist', ['hasPayoutMethod'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/PayoutMethod.vue